goog.provide('el8.shared.util.hmReminder');

// Utility functions for generating HM reminder from CQM status
// shared by patient chart LHS and printing

el8.shared.util.hmReminder = (function () {

    var that = {};

    function findEarliestDueDates(dueInfo) {
        var earliestDue = _.min(_.values(dueInfo), function(recordAndDueDates) {
            return recordAndDueDates[1] && recordAndDueDates[1].dueEndDate || Number.MAX_VALUE;
        });

        return earliestDue ? earliestDue[1] : null;
    }

    that.calculateHMReminders = function(cqmStatus, targetDate) {
        var queryYear = new Date(targetDate).getFullYear();
        var reminders = [];
        if (cqmStatus) {
            _.each(cqmStatus.reminders, function (reminderData, measureId) {
                if (!cqmStatus.health_maint_id_map[measureId]) { return; }
                if (!reminderData) { return; }

                /**
                * Respects practice settings on enabled CDSs by NQF Codes
                *
                * Note:
                *   On /settings/staff-display page the list of DecisionSupport toggles rely on NQF codes.
                *   NQF codes are shared between versions of MeasureDefinitions.
                *   Example:
                *       CMS124v10 -> 1710 measure code id -> 0032 nqf code
                *       CMS124v11 -> 1709 measure code id -> 0032 nqf code
                *
                * Opted for a simpler FE bandaid fix because a rather large refactoring opportunity exists in
                * get_patient_cqm_status() [elation/quality_measures/views.py] along with future HM/CDS refactorings.
                * */
                var nqfCode = cqmStatus.cds_identifier_map[measureId];
                // When nqfCode is undefined (e.g. for non-CMS measures like 'Advance Care Planning' [EL8001]) we get a
                // false from practiceSettings since those are based on nqfCodes.
                // Therefore, we use the OR operator below to catch the undefined nqfCode to enable that reminder.
                var isMeasureCDSEnabled = el8.data.practiceSettings.isStaffSupportEnabled(nqfCode) || !nqfCode;
                if (!isMeasureCDSEnabled) { return; }

                for (var i = 0; i < reminderData.spec.reminders.length; i++) {
                    var timelapse = reminderData.records[i];
                    var state = el8.shared.util.cqm.findReminderState(timelapse, targetDate);

                    if (!state.relevant) { continue; }

                    var reminder = reminderData.spec.reminders[i];
                    var dueInfo = el8.shared.util.cqm.getReminderItemDueInfo(reminder,
                        cqmStatus.results[measureId].timelapse_map, targetDate);
                    var dueDates = findEarliestDueDates(dueInfo.dueInfo);

                    var showDueDate = false;
                    if (dueDates) {
                        // TODO: The intent of dueSoonThreshold is to show a due
                        // date if the measure is satisfied this year but due
                        // again early next year. However, the logic below has
                        // a bug when the measure can be satisfied by one of
                        // several items, because the measure can be satisfied
                        // this year by one item and still show the due soon
                        // date this year for the remaining items.
                        // E.g. colorectal cancer screening exhibits this issue
                        //var dueSoonThreshold = 60 * 24 * 60 * 60 * 1000;
                        //var dueEndDate = dueDates.dueEndDate;
                        //showDueDate = !state.excluded && (state.pending ||
                        //   (dueEndDate !== null && dueEndDate < targetDate + dueSoonThreshold));

                        // TODO: This assumes that an exclusion in the current year means that we won't have to show a
                        // due date for the next year. This is the case for breast/cervical/colorectal screenings as the
                        // exclusions are permanent conditions.
                        showDueDate = !state.excluded && state.pending;
                    }

                    reminders.push({
                        primaryItemName: dueInfo.itemName,
                        state: state,
                        dueDates: showDueDate ? dueDates : null,
                        dueClassification: showDueDate ? el8.shared.util.cqm.classifyDueDates(dueDates, targetDate) : null,
                        queryYear: queryYear,
                        maintRuleId: cqmStatus.health_maint_id_map[measureId]
                    });
                }
            });

            reminders.sort(function (a, b) {
                function group(x) { return !x.state.excluded ? (x.state.pending ? 0 : 1) : 2; }
                function dueEnd(x) {
                    if (!x.dueDates || !x.dueDates.dueEndDate) { return Infinity; }
                    // Round to the nearest minute to avoid 1-second differences messing up the order
                    // (e.g. this can happen if one measure uses '<' and the other uses '<=')
                    return Math.round(x.dueDates.dueEndDate / (60 * 1000));
                }

                if (group(a) !== group(b)) {
                    return group(a) - group(b);
                }
                else if (dueEnd(a) !== dueEnd(b)) {
                    return dueEnd(a) - dueEnd(b);
                }
                else {
                    var nameA = a.primaryItemName.toLowerCase();
                    var nameB = b.primaryItemName.toLowerCase();

                    if (nameA < nameB) { return -1; }
                    else if (nameA > nameB) { return 1; }
                    else { return 0; }
                }
            });
        }

        return reminders;
    };

    return that;
})();
